import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import type { OrderView, PublicMenu } from '../../menu/types';

export type GuestSession = {
  session: { number: number; tableLabel: string; openedAt: string; billRequestedAt: string | null };
  orders: OrderView[];
  totals: { consumedCents: number; itemCount: number };
};

/** Comanda do cliente. 401/410 = sem mesa (ou comanda encerrada): o cardápio fica só para consulta. */
export function useGuestSession(poll = false) {
  return useQuery({
    queryKey: ['guest-session'],
    queryFn: () => api<GuestSession>('/api/public/session'),
    retry: false,
    // O normal é atualizar por SSE; a consulta periódica é só rede de segurança.
    refetchInterval: poll ? 30_000 : false,
    refetchIntervalInBackground: false,
  });
}

export function usePublicMenu() {
  return useQuery({ queryKey: ['public-menu'], queryFn: () => api<PublicMenu>('/api/public/menu'), staleTime: 30_000, refetchInterval: 120_000 });
}
